
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import config from '@/params/config';
@Component({
  components: {}
})
export default class DocMarkdown extends Vue {
  iframeH: any = 200;
  productID: any = '';
  versionId: any = '';
  gitBranchKey: any = '';
  syncTime: any = '';
  system: any = '';
  processurl=config.processurl;
  @Getter productDocs: any;
  @Action("getDocProducts") getDocProducts: Function;
  get sysList() {
    if(this.productDocs.infos && this.productDocs.infos.length > 0){
      var allChilds = this.productDocs.infos.flatMap((item: any) => item.children);
      return allChilds.filter((item: any) => item.DocVersions && item.DocVersions.length > 0) || [];
    }
    return [];
  }

  get verList() {    
    const vers =
      (this.sysList &&
        this.sysList.filter((item: any) => item.DocProductGUID === this.productID)) ||
      [];
    if (vers.length > 0) {
      return vers[0] && vers[0].DocVersions;
    } else {
      return [];
    }
  }
  get docSource() {
    let host = window.location.host;
    const protocol = window.location.protocol || 'http:';
    if (host.indexOf('10.20.32.49') == 0) {
      host = 'fangjq.mingyuanyun.com:7778';
    } else if(host.indexOf('cpzy.') === -1) {
      host = 'cpzy.mingyuanyun.com';
    }
    
    if(process.env.NODE_ENV === 'test'){
      host = '10.5.11.27:8000';
    }

    

    const src = `${protocol}//${host}/doc/product/${this.gitBranchKey}/index.html?t=` + new Date().getTime();        
    // const src = require('./docs/shoulou/index.html');
    const iframe =
      '<iframe src="' +
      src +
      '" frameborder="no" width="100%" height="' +
      this.iframeH +
      '"></iframe>';

    return iframe;
  }
  created() {
    this.getDocProducts();
    this.productID = (this.$route.query.productID as any);
  }
  mounted() {
    this.iframeH =
      (document.querySelector('.layout-box') as any).offsetHeight - 65 - 85;

    window.addEventListener('resize', () => {
      this.iframeH =
        (document.querySelector('.layout-box') as any).offsetHeight - 65 - 85;
    });
  }

  @Watch('verList', { immediate: true, deep: true })
  watchVer(newVal: any) {
    this.versionId = (this.verList[0] && this.verList[0].DocVersionGUID) || '';
  }

  @Watch('versionId', { immediate: true, deep: true })
  watchSys(newVal: any) {
    this.gitBranchKey = (this.verList[0] && this.verList.filter((item: any) => item.DocVersionGUID === newVal)[0].GitBranchKey)|| 'v1';
  }
}
